import normalizeSearchState from './normalizeSearchState'
import { CustomeSearchState } from '@/types/models'
import { getSessionStorageSearchState } from '@/utils/search/searchState'
import removeEmptyKeysAndValues from '@/utils/removeEmptyKeysAndValues'
import { updateRefinementList } from './updateRefinementList'

interface RefineSearchStateByLocations {
  (props: {
    simpleLocationName: string
    locationName: string
    locationType: string
  }): Partial<CustomeSearchState>
}

const refineSearchStateByLocations: RefineSearchStateByLocations = ({
  simpleLocationName,
  locationName,
  locationType
}) => {
  const searchState: CustomeSearchState = getSessionStorageSearchState() || {}

  const searchStateNormalized = normalizeSearchState({
    ...searchState,
    locationName,
    locationType
  })

  const configureCleared = removeEmptyKeysAndValues({
    ...searchStateNormalized.configure,
    aroundLatLng: null,
    aroundRadius: null,
    aroundPrecision: null
  })

  const updatedRefinements = updateRefinementList({
    refinementList: searchStateNormalized.refinementList || {},
    updates: {
      locations: [simpleLocationName]
    }
  })
  const clearedSearchState = removeEmptyKeysAndValues({
    ...searchStateNormalized,
    aroundLatLng: null,
    locationName: null,
    locationType: null,
    customLocationRadiusInMiles: null,
    refinementList: updatedRefinements,
    configure: configureCleared
  })

  const lastNormalization = normalizeSearchState(clearedSearchState)

  return lastNormalization
}

export default refineSearchStateByLocations
